export const enum IndiaBank {
    ICICI = 'ICICI',
    HDFC = 'HDFC',
    // Funding Instructions Beneficiary Details
    FIBD = 'FIBD',
    // Axis banks nickname will include the word 'Axis'
    AXIS = 'Axis',
}
